// extracted by mini-css-extract-plugin
export var chip = "_e3-0";
export var filterDropdown = "_e3-5";
export var filterItem = "_e3-6";
export var icon = "_e3-1";
export var removeButton = "_e3-3";
export var removeIcon = "_e3-4";
export var separator = "_e3-2";